import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CustomCn } from '@gate31/core/src/libs/classname';

export class LoyaltyCupon extends Base<HTMLElement> {
    cn: CustomCn;

    couponWrapper: HTMLDivElement | null
    couponHeader: HTMLDivElement | null
    couponResetButton: HTMLElement | null
    couponError: HTMLDivElement | null
    couponSubmitButton: HTMLButtonElement | null

    fieldCupon: HTMLInputElement | null

    constructor(options: { node: HTMLElement; cn: CustomCn }) {
        super(options.node);

        this.cn = options.cn;

        this.couponWrapper = document.querySelector<HTMLDivElement>(this.cn.setElem('coupon').toSelector());
        this.couponHeader = document.querySelector<HTMLDivElement>(this.cn.setElem('coupon-header').toSelector());
        this.couponError = document.querySelector<HTMLDivElement>(this.cn.setElem('coupon-error').toSelector());

        this.fieldCupon = document.querySelector<HTMLInputElement>(this.cn.setElem('coupon-input').toSelector());

        this.couponResetButton = document.querySelector<HTMLElement>(this.cn.setElem('coupon-reset-button').toSelector());
        this.couponSubmitButton = document.querySelector<HTMLButtonElement>(this.cn.setElem('coupon-send-button').toSelector());

        this.connectionCallback();
    }

    connectionCallback() {
        this.fieldCupon?.addEventListener('input', () => this.changeValue());
        this.couponHeader?.addEventListener('click', () => this.toggleForm());
    }

    toggleForm() {
        this.couponWrapper?.classList.toggle(this.cn.setElem('coupon').setMode({ show: true }).toString());
    }

    showForm() {
        // code...
    }

    changeValue() {
        const value = this.fieldCupon?.value;

        if (value !== '') {
            this.couponSubmitButton?.removeAttribute('disabled');
        } else {
            this.couponSubmitButton?.setAttribute('disabled', 'true');
        }

        this.hideCouponError();
    }

    hideCouponError() {
        if (! this.couponError) {
            return;
        }
        this.couponError.style.display = 'none';
    }

    renderError(message?: string) {
        if (! message) {
            this.hideCouponError();
            return;
        }

        if (! this.couponError) {
            return;
        }

        this.couponError.innerHTML = message;
    }
}
